import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    paddingLeft: "0px !important",
    paddingRight: "0px !important",
  },
  mainContainer: {
    flexGrow: 1,
    backgroundColor: "#FEFEFE",
    minHeight: "100vh",
    boxShadow: "0 0 3px 1px rgba(0,0,0,.1)",
  },
  root: {
    height: "100vh",
  },
  contentWrapper: {
    margin: 10,
  },
  wrap: {
    paddingTop: "70px",
    marginBottom: "20px",
  },
  wrapRiwayat: {
    paddingTop: "60px",
    marginBottom: "20px",
  },
  wrapCard: {
    padding: "15px",
    backgroundColor: "#5675D3",
  },
  wrapContentCard: {
    display: "flex",
    justifyContent: "space-between",
    padding: "10px",
  },
  wrapContentTitle: {
    padding: "10px",
  },
  liquidCardTitle: {
    fontSize: "16px",
    color: "white",
  },
  liquidCardPrimary: {
    fontSize: "14px",
    color: "white",
  },
  liquidCardSecondary: {
    fontSize: "11px",
    color: "white",
  },
  wrapVoucher: {
    padding: "10px",
  },
  cardVoucher: {
    display: "flex",
    padding: "10px",
    cursor: "pointer",
  },
  liquidVocherPrimary: {
    fontSize: "14px",
  },
  liquidVocherSecondary: {
    fontSize: "12px",
    color: "#88929F",
  },
  labelKomisi: {
    backgroundColor: "#e82868",
    fontSize: 11,
    lineHeight: "20px",
    color: "#fff",
    display: "inline-block",
    padding: "0 4px",
    borderRadius: 4,
    marginBottom: 4,
    "@media(min-width: 280px)": {
      fontSize: 9,
      padding: "0 3px",
    },
    "@media(min-width: 320px)": {
      fontSize: 9,
      padding: "0 3px",
    },
    "@media(min-width: 360px)": {
      fontSize: 9,
      padding: "0 3px",
    },
  },
  wrapThumb: {
    width: 70,
    display: "flex",
    alignItems: "center",
    "@media(max-width: 280px)": {
      width: 35,
    },
    "@media (max-width: 360px)": {
      width: 35,
    },
    "@media(min-width: 960px)": {
      width: 70,
    },
  },
  thumb: {
    objectFit: "cover",
    width: "100%",
  },
  fullWidth: {
    width: "100%",
  },
  paper: {
    maxHeight: "100vh",
    height: "100vh",
  },
  root: {
    margin: 0,
    // marginLeft: -8,
    borderRadius: 0,
    marginTop: 50,
  },
  btn: {
    textTransform: "capitalize",
  },
  carousel: {
    width: "100%",
    height: 360,
    borderBottom: "1px solid #E5E5E5",
  },
  head: {
    display: "flex",
    alignItems: "center",
    padding: "12px 0px 6px",
  },
  title: {
    // flex: 1,
    margin: "0 10px",
    fontSize: 12,
    // fontWeight: 00,
    color: "#2f2f2f",
  },
  body: {
    color: "#848484",
    padding: "8px 0 18px 10px",
  },
  body: {
    color: "#848484",
    padding: "8px 0 18px 10px",
  },
  bodyTitle: {
    fontSize: 12,
    // maxWidth: 10,
    marginTop: 5,
    marginBottom: -10,
    marginLeft: 25,
    marginRight: 20,
  },
  titleBody: {
    // width: "100%",
    // margin: 0,
    marginLeft: 25,
    fontSize: 14,
    fontWeight: 700,
    color: "#2f2f2f",
  },
  descHead: {
    textDecoration: "none",
    padding: "12px 16px",
    display: "flex",
    justifyContent: "space-between",
    color: "inherit",
  },
  descBody: {
    padding: "0px 16px 16px",
    whiteSpace: "pre-line",
  },
  wrapIcon: {
    width: 40,
    "@media(max-width: 280px)": {
      width: 35,
    },
    "@media (max-width: 360px)": {
      width: 35,
    },
    "@media(min-width: 960px)": {
      width: 35,
    },
  },
  icon: {
    objectFit: "cover",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  liquidPont: {
    fontSize: "13px",
    color: "#F2BA4C",
  },
  liquidBtn: {
    fontSize: "12px",
    color: "white",
  },
  boxButton: {
    display: "flex",
    flexDirection: "row",
    height: 50,
    maxWidth: "100%",
    width: 960,
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    margin: "0 auto",
    paddingLeft: 30,
    // paddingRight: 30,
    zIndex: 999,
    // backgroundColor: "#5675D3",
    boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)",
  },
  buttonSelect: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "white",
    width: "40%",
    marginLeft: -30,
    cursor: "pointer",
  },
  buttonSelect1: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "90%",
    backgroundColor: "#5675D3",
    cursor: "pointer",
    boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)",
  },
  hero: {
    objectFit: "cover",
    width: "100%",
  },
  wrapHero: {
    padding: 20,
    margin: 20,
    zIndex: 0,
  },
  wrapHari:{
    display: "flex", justifyContent: "center"
  },
  hari:{
    padding: "6px",
    margin: "2px",
    borderRadius: "4px",
  },
  liquidListPrimary: {
    fontSize: 14,
  },
  liquidListSecond: {
    fontSize: 14,
    color: theme.palette.textColor.gray,
  },
  liquidSecondList:{
    maxWidth:"200px",
    fontSize: 12,
    color: theme.palette.textColor.gray,
  },
  liquidListThird: {
    fontSize: 12,
    color: theme.palette.primary.main,
  },
  dialog: {
    padding: "0px !important",
    overflow: "hidden",
  },
  dialogContent: {
    paddingTop: "0px !important",
    padding: "0px !important",
    overflow: "hidden",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
}));

export default useStyles;
